import React, { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store/index";

// Import CSS files
import "../src/Shared/Css/bootstrap.min.css";
import "../src/Shared/Css/bootstrap.bundle.js";
import "../src/Shared/Css/fonts.Robot.css";
import "../src/Shared/Css/fonts.icon.css";
import "../src/Shared/Css/signin.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <StrictMode>
      <App />
    </StrictMode>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
